(function () {
  'use strict';

  var BODY_OPEN_CLASS = 'fid-drawer-open';

  function openDrawer(name, trigger) {
    var drawer = document.querySelector('[data-fid-drawer="' + name + '"]');
    if (!drawer) return;

    var panel = drawer.querySelector('.fid-drawer__panel');
    window.fidLastDrawerTrigger = trigger || null;

    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add(BODY_OPEN_CLASS);

    document.querySelectorAll('[data-fid-drawer-open="' + name + '"]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });

    window.setTimeout(function () {
      if (panel) panel.focus({ preventScroll: true });
    }, 30);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;

    var name = drawer.getAttribute('data-fid-drawer');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(BODY_OPEN_CLASS);

    if (name) {
      document.querySelectorAll('[data-fid-drawer-open="' + name + '"]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    }

    if (window.fidLastDrawerTrigger && typeof window.fidLastDrawerTrigger.focus === 'function') {
      window.fidLastDrawerTrigger.focus();
    }

    window.fidLastDrawerTrigger = null;
  }

  function switchAccountPanel(target) {
    var drawer = document.querySelector('[data-fid-drawer="account"]');
    if (!drawer || !target) return;

    var panels = drawer.querySelectorAll('[data-fid-account-panel]');
    var tabs = drawer.querySelectorAll('[data-fid-account-tab]');

    panels.forEach(function (panel) {
      var isTarget = panel.getAttribute('data-fid-account-panel') === target;
      panel.classList.toggle('is-active', isTarget);
      panel.hidden = !isTarget;
    });

    tabs.forEach(function (tab) {
      var isTarget = tab.getAttribute('data-fid-account-tab') === target;
      var isMainTab = target === 'login' || target === 'register';

      if (tab.getAttribute('role') === 'tab') {
        tab.classList.toggle('is-active', isTarget && isMainTab);
        tab.setAttribute('aria-selected', isTarget && isMainTab ? 'true' : 'false');
      }
    });

    if (target === 'recover') {
      tabs.forEach(function (tab) {
        if (tab.getAttribute('role') === 'tab') {
          tab.classList.remove('is-active');
          tab.setAttribute('aria-selected', 'false');
        }
      });
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-fid-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-fid-drawer-open'), opener);
      return;
    }

    var closer = event.target.closest('[data-fid-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('[data-fid-drawer]'));
      return;
    }

    var accountTab = event.target.closest('[data-fid-account-tab]');
    if (accountTab) {
      event.preventDefault();
      switchAccountPanel(accountTab.getAttribute('data-fid-account-tab'));
    }
  });

  document.addEventListener('keydown', function (event) {
    var activeDrawer = document.querySelector('[data-fid-drawer][aria-hidden="false"]');
    if (!activeDrawer) return;

    if (event.key === 'Escape') {
      closeDrawer(activeDrawer);
    }
  });
})();
